import React from 'react';
import useStyles from './styles';
import { Chip, Avatar } from '@material-ui/core';
import { getIconLearningContent } from '../../../utils/helpers/icon/iconHelper'
import clsx from 'clsx';

const Coin = ({
    coin,
    customClass,
    takeAssessment = false,
    size,
    color,
}) => {
    const classes = useStyles()
    return (
        <>
            <Chip
                avatar={
                    <Avatar 
                        classes={{
                            colorDefault: classes.colorDefaultAvatar,
                        }}
                        className={clsx(
                            classes.avatarDefault,
                            size === 'big' && classes.avatarBig, 
                            size === 'medium' && classes.avatarMedium,
                            size === 'small' && classes.avatarSmall,
                        )}
                    >
                        <img src={`${getIconLearningContent().ic_lc_coin}`}/>
                    </Avatar>
                }
                label={coin}
                classes={{ label: classes.label, root: classes.rootChip }}
                className={clsx(
                    classes.chipDefault,
                    // classes[`${customClass}`],
                    color === 'plus' && classes.iconPlus,
                    color === 'substract' && classes.iconSubstract,
                    color === 'non-border' && classes.iconNonBorder,
                    takeAssessment && classes.btnTakeAssessment,
                    size === 'big' && classes.chipSizeBig, 
                    size === 'medium' && classes.chipSizeMedium,
                    size === 'small' && classes.chipSizeSmall,
                    // disabled && classes.isDisabled,
                )}
            />
        </>
    )
}

export default Coin